import React, { Component, Fragment, useEffect, useState } from 'react';
import { Steps, Step, Wizard } from 'react-albus';
import { withRouter } from 'react-router-dom';
import { compose, withApollo } from 'react-apollo';
import { Box, Flex } from 'rebass';
import { withToastManager } from 'react-toast-notifications';
import styled, { keyframes } from 'styled-components';

import FullLayout from '../../components/FullLayout';
import LoadingScreen from '../../components/LoadingScreen';
import Basic from './Basic';
import Profile from './Profile';
import Extended from './Extended';
import moment from 'moment';

import { GET_ANALYTICS_ID, MEMBERSHIP_CREATE_SESSION, SIGNUP, SIGNUP_WEIGHTLOSS } from '../../graphql';
import withAnalytics from '../../lib/withAnalytics';
import Otp from './Otp';
import GenderIdentity from './GenderIdentity';
import PreferredPronouns from './PreferredPronouns';
import BirthSex from './BirthSex';
import LegalSex from './LegalSex';
import { withCookies } from 'react-cookie';
import theme from '../../styles/theme';
import { ComponentWrap } from '../weightLossPrequalification/components/ComponentWrap';
import { LogoSvg } from '../weightLossPrequalification/components/Logo';
import { ExperiencedDiagnosed, OPTIONS as OPTIONS_DIAGNOSED } from '../weightLossPrequalification/components/ExperiencedDiagnosed';
import { ConditionsNext, OPTIONS as OPTIONS_CONDITIONS_NEXT } from '../weightLossPrequalification/components/ConditionsNext';
import { Conditions, OPTIONS as OPTIONS_CONDITIONS } from '../weightLossPrequalification/components/Conditions';
import { useMount } from '../../utils/hooks/lifecycle';
import { useHasChanged, usePrevious, useUpdateEffect } from '../../utils/hooks/lifecycle/useUpdateEffect';
import { mutationPrep } from '../weightLossPrequalification/helpers/mutationPrep';
import { loadStripe } from '@stripe/stripe-js';
import { getFbclid, getFbp, getGa, getGclAw } from '../../utils/fbclid';

const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateY(15px);
  };
  100% {
    opacity: 1;
    transform: translateY(0px);
  };
`;
const initalState = {
  isInitialized: false,
  values: {
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    phone: '',
    gender: '',
    genderidentity: '',
    genderidentityother: null,
    street1: '',
    street2: '',
    city: '',
    state: '',
    zip: '',
    consent: false,
    diagnosed: null,
    mfa: null,
    bypassOtp: false,
  },
};

const Container = styled(Box)`
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
`;

const Pb = styled(Flex)`
  transition: all 0.35s ease;
`;

const hasFilledPrequalification = (values) => {
  if (!values) {
    return false;
  }
  if (!values.prestate || !values.dob) {
    return false;
  }

  return true;
};

const STEPS_CONTROL = [
  {
    id: '/wm',
    set: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi', '_diagnosis', '_conditions1', '_conditions2'],
    requisite: [],
  },
  {
    id: 'profile',
    set: ['firstName', 'lastName', 'street1', 'zip', 'city', 'state', 'phone'],
    requisite: ['weightLossGoal', 'prestate', 'dob', 'assignedsexatbirth', 'feet', 'inches', 'pounds', 'bmi', '_diagnosis', '_conditions1', '_conditions2'],
  },
  {
    id: 'otp',
    set: ['mfa'],
    requisite: [
      'weightLossGoal',
      'prestate',
      'dob',
      'assignedsexatbirth',
      'feet',
      'inches',
      'pounds',
      'bmi',
      '_diagnosis',
      '_conditions1',
      '_conditions2',
      'firstName',
      'lastName',
      'street1',
      'zip',
      'city',
      'state',
      'phone',
    ],
  },
  {
    id: 'birthsex',
    set: ['_gendersame'],
    requisite: [
      'weightLossGoal',
      'prestate',
      'dob',
      'assignedsexatbirth',
      'feet',
      'inches',
      'pounds',
      'bmi',
      '_diagnosis',
      '_conditions1',
      '_conditions2',
      'firstName',
      'lastName',
      'street1',
      'zip',
      'city',
      'state',
      'phone',
      'mfa',
    ],
  },
  {
    id: 'legalsex',
    set: ['legalSex'],
    requisite: [
      'weightLossGoal',
      'prestate',
      'dob',
      'assignedsexatbirth',
      'feet',
      'inches',
      'pounds',
      'bmi',
      '_diagnosis',
      '_conditions1',
      '_conditions2',
      'firstName',
      'lastName',
      'street1',
      'zip',
      'city',
      'state',
      'phone',
      'mfa',
      '_gendersame',
    ],
  },
  {
    id: 'genderIdentity',
    set: ['genderidentity'],
    requisite: [
      'weightLossGoal',
      'prestate',
      'dob',
      'assignedsexatbirth',
      'feet',
      'inches',
      'pounds',
      'bmi',
      '_diagnosis',
      '_conditions1',
      '_conditions2',
      'firstName',
      'lastName',
      'street1',
      'zip',
      'city',
      'state',
      'phone',
      'mfa',
      '_gendersame',
    ],
  },
  {
    id: 'pronouns',
    set: ['preferredpronouns'],
    requisite: [
      'weightLossGoal',
      'prestate',
      'dob',
      'assignedsexatbirth',
      'feet',
      'inches',
      'pounds',
      'bmi',
      '_diagnosis',
      '_conditions1',
      '_conditions2',
      'firstName',
      'lastName',
      'street1',
      'zip',
      'city',
      'state',
      'phone',
      'mfa',
      '_gendersame',
    ],
  },
  {
    id: 'medical-history-consent',
    set: ['medicationHistoryConsentVerified'],
    requisite: [
      'weightLossGoal',
      'prestate',
      'dob',
      'assignedsexatbirth',
      'feet',
      'inches',
      'pounds',
      'bmi',
      '_diagnosis',
      '_conditions1',
      '_conditions2',
      'firstName',
      'lastName',
      'street1',
      'zip',
      'city',
      'state',
      'phone',
      'mfa',
      '_gendersame',
    ],
  },
  {
    id: 'account',
    set: ['email', 'password'],
    requisite: [
      'weightLossGoal',
      'prestate',
      'dob',
      'assignedsexatbirth',
      'feet',
      'inches',
      'pounds',
      'bmi',
      '_diagnosis',
      '_conditions1',
      '_conditions2',
      'firstName',
      'lastName',
      'street1',
      'zip',
      'city',
      'state',
      'phone',
      'mfa',
      '_gendersame',
    ],
  },
];

const STEPS_CONTROL_DISQUALIFIED = [
  {
    id: '/wm',
    set: ['prestate', 'dob', 'assignedsexatbirth', 'hypothyroidism'],
    requisite: [],
  },
  {
    id: 'profile',
    set: ['firstName', 'lastName', 'street1', 'zip', 'city', 'state', 'phone'],
    requisite: ['prestate', 'dob', 'assignedsexatbirth', 'hypothyroidism'],
  },
  {
    id: 'otp',
    set: ['mfa'],
    requisite: ['prestate', 'dob', 'assignedsexatbirth', 'hypothyroidism', 'firstName', 'lastName', 'street1', 'zip', 'city', 'state', 'phone'],
  },
  {
    id: 'birthsex',
    set: ['_gendersame'],
    requisite: ['prestate', 'dob', 'assignedsexatbirth', 'hypothyroidism', 'firstName', 'lastName', 'street1', 'zip', 'city', 'state', 'phone', 'mfa'],
  },
  {
    id: 'legalsex',
    set: ['legalSex'],
    requisite: ['prestate', 'dob', 'assignedsexatbirth', 'hypothyroidism', 'firstName', 'lastName', 'street1', 'zip', 'city', 'state', 'phone', 'mfa', '_gendersame'],
  },
  {
    id: 'genderIdentity',
    set: ['genderidentity'],
    requisite: ['prestate', 'dob', 'assignedsexatbirth', 'hypothyroidism', 'firstName', 'lastName', 'street1', 'zip', 'city', 'state', 'phone', 'mfa', '_gendersame'],
  },
  {
    id: 'pronouns',
    set: ['preferredpronouns'],
    requisite: ['prestate', 'dob', 'assignedsexatbirth', 'hypothyroidism', 'firstName', 'lastName', 'street1', 'zip', 'city', 'state', 'phone', 'mfa', '_gendersame'],
  },
  {
    id: 'medical-history-consent',
    set: ['medicationHistoryConsentVerified'],
    requisite: ['prestate', 'dob', 'assignedsexatbirth', 'hypothyroidism', 'firstName', 'lastName', 'street1', 'zip', 'city', 'state', 'phone', 'mfa', '_gendersame'],
  },
  {
    id: 'account',
    set: ['email', 'password'],
    requisite: ['prestate', 'dob', 'assignedsexatbirth', 'hypothyroidism', 'firstName', 'lastName', 'street1', 'zip', 'city', 'state', 'phone', 'mfa', '_gendersame'],
  },
];

const RegistrationWeightLoss = (props) => {
  if (!!window.localStorage.getItem('wm-d') || !!window.localStorage.getItem('wm-df')) {
    return <RegistrationWeightLoss_Disqualified {...props} />;
  }

  return <RegistrationWeightLoss_ {...props} />;
};

const RegistrationWeightLoss_ = (props) => {
  const [state, setState] = useState(window.sessionStorage.getItem('wmi') !== null ? JSON.parse(window.sessionStorage.getItem('wmi')) : {});
  const [enforceDepartment, setEnforceDepartment] = useState();
  const [isInitialized, setIsInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const tagHasChanged = useHasChanged(props.location.pathname);
  const [previousPage, setPreviousPage] = useState();

  useEffect(() => {
    const { history } = props;
    const wmi = window.sessionStorage.getItem('wmi');
    if (!wmi) {
      history.replace('/wm');
    }
    const parsed = JSON.parse(window.sessionStorage.getItem('wmi'));
    if (!parsed) {
      history.replace('/wm');
    }

    const canContinue = hasFilledPrequalification(parsed);

    if (!canContinue) {
      history.replace('/wm');
    }
    setEnforceDepartment(parsed['prestate']);
    setIsInitialized(true);
  }, []);

  useEffect(
    () => {
      // console.log('ue', props.location);

      if (props.location.pathname !== previousPage) {
        let tag = (props.location.pathname || '').replace('/wm', '');
        if (props.location.pathname.indexOf('basic') > -1) {
          tag = 'basic';
        } else if (props.location.pathname.indexOf('profile') > -1) {
          tag = 'profile';
        } else if (props.location.pathname.indexOf('extended') > -1) {
          tag = 'extended';
        }
        if (tag) {
          // console.log('useEffect', tag);
          props.analytics.page(tag, '/wm');
        }
        setPreviousPage(props.location.pathname);
        checkRequisites();
      }
    },
    [props.location],
  );

  const checkRequisites = () => {
    const locat = STEPS_CONTROL.find((x) => x.id === props.location.pathname.replace('/wm/', ''));
    if (!locat) {
      return;
    }
    for (let index = 0; index < locat.requisite.length; index++) {
      const element = locat.requisite[index];
      if (element.indexOf('_') === 0) {
        if (element === '_diagnosis') {
          const opts = OPTIONS_DIAGNOSED;
          let found = false;
          for (let ind2 = 0; ind2 < opts.length; ind2++) {
            const o = opts[ind2];
            if (!!state[o.id]) {
              found = true;
            }
          }
          if (!found) {
            const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
            if (!target) continue;
            props.history.replace(`/wm/${target.id}`);
          }
        }
        if (element === '_conditions1') {
          const opts = OPTIONS_CONDITIONS;
          let found = false;
          for (let ind2 = 0; ind2 < opts.length; ind2++) {
            const o = opts[ind2];
            if (!!state[o.id]) {
              found = true;
            }
          }
          if (!found) {
            const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
            if (!target) continue;
            props.history.replace(`/wm/${target.id}`);
          }
        }
        if (element === '_conditions2') {
          const opts = OPTIONS_CONDITIONS_NEXT;
          let found = false;
          for (let ind2 = 0; ind2 < opts.length; ind2++) {
            const o = opts[ind2];
            if (!!state[o.id]) {
              found = true;
            }
          }
          if (!found) {
            const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
            if (!target) continue;
            props.history.replace(`/wm/${target.id}`);
          }
        }
        continue;
      }
      if (state[element]) {
        // console.log('found')
      } else {
        // console.log('notFound');
        const target = STEPS_CONTROL.find((x) => x.set.indexOf(element) > -1);
        if (!target) continue;
        if (target.id === 'prequal') {
          props.history.replace(`/wm`);
          return;
        }
        props.history.replace(`/wm-registration/${target.id}`);
      }
    }
  };

  const handleSubmit = (values, actions, wizard, force) => {
    // this.setState({ values: { ...values } });

    if (!!actions && !!actions.setSubmitting) {
      actions.setSubmitting(false);
    }
    if (!!force) {
      wizard.push(force);
    } else {
      wizard.next();
    }
  };

  const handleChange = (id, value, clearValue) => {
    const s = JSON.parse(JSON.stringify(state));
    s[id] = value;
    if (!!clearValue) {
      if (Array.isArray(clearValue)) {
        for (let index = 0; index < clearValue.length; index++) {
          const element = clearValue[index];
          delete s[element];
        }
      } else {
        delete s[clearValue];
      }
    }
    setState(s);
    const d = JSON.stringify(s);
    window.sessionStorage.setItem('wmi', d);
  };

  const handleChangeMultiple = (idValues) => {
    const s = JSON.parse(JSON.stringify(state));
    for (let index = 0; index < idValues.length; index++) {
      const element = idValues[index];
      const { id, value } = element;
      s[id] = value;
    }

    setState(s);
    const d = JSON.stringify(s);
    window.sessionStorage.setItem('wmi', d);
  };

  const handleComplete = async (values, medicalConsent, wizard) => {
    const { toastManager, analytics } = props;
    setIsCreating(true);
    const wmi = JSON.parse(window.sessionStorage.getItem('wmi'));
    const {
      weightLossGoal,
      prestate,
      dob,
      assignedsexatbirth,
      feet,
      inches,
      pounds,
      bmi,
      _diagnosis,
      _conditions1,
      _conditions2,
      firstName,
      lastName,
      street1,
      street2,
      zip,
      city,
      state,
      phone,
      mfa,
      _gendersame,
      email,
      password,
      medicationHistoryConsentVerified,
      legalSex,
      genderidentity,
      gender,
      otherGenderIdentity,
      preferredpronouns,
      hypothyroidism,
    } = wmi;

    const { isSubscribe, continueWith, frequency, forwardToSelectPlan, trial, enforceDepartment } = state;
    let charts = mutationPrep(wmi);
    let diagnosed = !!hypothyroidism || false;

    try {
      let fbclid = getFbclid();
      let fbp = getFbp();
      let ga_client_id = getGa();
      let gclid = getGclAw();
      const { data } = await props.client.mutate({
        mutation: SIGNUP_WEIGHTLOSS,
        variables: {
          email: email,
          phone: phone,
          password: values.password,
          firstName: firstName,
          lastName: lastName,
          street1: street1,
          street2: street2,
          city: city,
          state: state,
          zip: zip,
          dob: dob,
          gender: gender || assignedsexatbirth,
          diagnosed: diagnosed,
          medicationHistoryConsentVerified: medicationHistoryConsentVerified === 'yes',
          genderidentity: genderidentity || assignedsexatbirth === 'M' ? 'Identifies as Male' : 'Identifies as Female',
          genderidentityother: otherGenderIdentity,
          preferredpronouns: preferredpronouns,
          assignedsexatbirth: assignedsexatbirth,
          isNPThyroid: false,
          oneTimeException: false,
          charts: charts,
          fbclid,
          fbp,
          ga_client_id,
          gclid,
        },
      });

      const attemptedRoute = localStorage.getItem('route');
      localStorage.setItem('token', data.signupWeightloss.token);
      const aa = await props.client.query({
        query: GET_ANALYTICS_ID,
        fetchPolicy: 'network-only',
      });
      let age = 0;
      try {
        age = moment().diff(moment(dob, 'MM/DD/YYYY'), 'years');
      } catch (error) {}
      if (aa && aa.data && aa.data.getAnalyticsId) {
        analytics.Alias(aa.data.getAnalyticsId);
        analytics.Identify(aa.data.getAnalyticsId, {
          age,
          gender: gender,
          state: state,
          diagnosed: diagnosed,
        });
      }

      analytics.track('Account Created', {
        age,
        gender: gender,
        diagnosed: diagnosed,
        state: state,
      });
      window.sessionStorage.removeItem('wmi');
      window.localStorage.removeItem('wm-d');
      window.localStorage.removeItem('wm-df');
      setIsCreating(false);
      await goToPurchase();
    } catch (error) {
      console.log(error);
      // actions.setSubmitting(false);

      // error.graphQLErrors.forEach((error) => {
      //   toastManager.add(error.message, {
      //     appearance: 'error',
      //     autoDismiss: true,
      //   });
      // });
    }
  };
  const goToPurchase = async () => {
    props.history.push('/become-member?showRes=true');
    // let priceId = window._env_.REACT_APP_MEMBERSHIP_SKU_ANNUAL_WEIGHT_LOSS;
    // const createSession = await props.client.mutate({
    //   mutation: MEMBERSHIP_CREATE_SESSION,
    //   variables: {
    //     priceId: priceId,
    //     forwardUrl: 'schedulewl',
    //     cancel_url: '/',
    //     trial: false,
    //   },
    // });

    // const stripePromise = loadStripe(window._env_.REACT_APP_STRIPE_KEY);
    // const stripe = await stripePromise;
    // await stripe.redirectToCheckout({
    //   sessionId: createSession.data.createCheckoutSession.sessionId,
    // });
  };

  if (loading || !isInitialized) {
    return <LoadingScreen loading={true} />;
  }

  return (
    <Fragment>
      <Container flex={1} px={3}>
        <Wizard
          history={props.history}
          basename="/wm-registration"
          render={({ step, ...p }, a) => {
            return (
              <>
                <Flex flexDirection={'row'} style={{ width: '100%', height: '6px' }} mt={2} id="pgbar">
                  <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: '#6aac6e', opacity: 0.33, width: '33px' }} />
                  <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: 'rgba(0, 0, 0, 0.12)', marginLeft: '12px' }} flex={1} id="ttt">
                    <Pb
                      flex={(p.steps.findIndex((x) => x.id === step.id) + 1) / p.steps.length}
                      style={{ background: theme.color.pink, borderTopRightRadius: '3px', borderBottomRightRadius: '3px' }}
                    />
                    <Pb flex={1 - (p.steps.findIndex((x) => x.id === step.id) + 1) / p.steps.length} style={{ background: 'transparent' }} />
                  </Flex>
                  <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: 'rgba(0, 0, 0, 0.12)', width: '33px', marginLeft: '12px' }} />
                </Flex>
                <Steps>
                  <Step id="profile">
                    <ComponentWrap>
                      <LogoSvg />
                      <Profile
                        onContinue={() => {
                          if (!state['mfa'] || state['mfa'] !== 'ok') {
                            p.push('otp');
                          } else {
                            p.push('birthsex');
                          }
                        }}
                        state={state}
                        enforceDepartment={enforceDepartment}
                        onChange={handleChange}
                        onChangeMultiple={handleChangeMultiple}
                      />
                    </ComponentWrap>
                  </Step>
                  <Step id="otp">
                    <ComponentWrap>
                      <LogoSvg />
                      <Otp state={state} onChange={handleChange} onChangeMultiple={handleChangeMultiple} onContinue={() => p.push('birthsex')} />
                    </ComponentWrap>
                  </Step>
                  <Step id="birthsex">
                    <ComponentWrap>
                      <LogoSvg />
                      <BirthSex
                        onSubmit={handleSubmit}
                        state={state}
                        onChange={handleChange}
                        onContinue={() => {
                          if (state['state'] === 'CA') {
                            p.push('medical-history-consent');
                          } else {
                            p.push('account');
                          }
                        }}
                        onChangeIdentify={() => p.push('legalsex')}
                      />
                    </ComponentWrap>
                  </Step>
                  <Step id="legalsex">
                    <ComponentWrap>
                      <LogoSvg />
                      <LegalSex state={state} onChange={handleChange} onContinue={() => p.push('genderIdentity')} onSubmit={handleSubmit} values={state} />
                    </ComponentWrap>
                  </Step>
                  <Step id="genderIdentity">
                    <ComponentWrap>
                      <LogoSvg />
                      <GenderIdentity onSubmit={handleSubmit} state={state} onChange={handleChange} onChangeMultiple={handleChangeMultiple} onContinue={() => p.push('pronouns')} />
                    </ComponentWrap>
                  </Step>
                  <Step id="pronouns">
                    <ComponentWrap>
                      <LogoSvg />
                      <PreferredPronouns
                        state={state}
                        onChange={handleChange}
                        onChangeMultiple={handleChangeMultiple}
                        onContinue={() => {
                          if (state['state'] === 'CA') {
                            p.push('medical-history-consent');
                          } else {
                            p.push('account');
                          }
                        }}
                      />
                    </ComponentWrap>
                  </Step>
                  <Step id="medical-history-consent">
                    <ComponentWrap>
                      <LogoSvg />
                      <Extended onChange={handleChange} onContinue={() => p.push('account')} state={state} />
                    </ComponentWrap>
                  </Step>
                  <Step id="account">
                    <ComponentWrap>
                      <LogoSvg />
                      <Basic onSubmit={handleComplete} state={state} onChange={handleChange} isCreating={isCreating} />
                    </ComponentWrap>
                  </Step>
                </Steps>
              </>
            );
          }}
        />
      </Container>
      <FullLayout />
    </Fragment>
  );
};

const RegistrationWeightLoss_Disqualified = (props) => {
  const [state, setState] = useState(window.sessionStorage.getItem('wmi') !== null ? JSON.parse(window.sessionStorage.getItem('wmi')) : {});
  const [enforceDepartment, setEnforceDepartment] = useState();
  const [isInitialized, setIsInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const tagHasChanged = useHasChanged(props.location.pathname);
  const [previousPage, setPreviousPage] = useState();

  useEffect(() => {
    const { history } = props;
    const wmi = window.sessionStorage.getItem('wmi');
    // console.log({ wmi });
    if (!wmi) {
      history.replace('/wm');
    }
    const parsed = JSON.parse(window.sessionStorage.getItem('wmi'));
    if (!parsed) {
      history.replace('/wm');
    }

    const canContinue = hasFilledPrequalification(parsed);

    if (!canContinue) {
      history.replace('/wm');
    }
    setEnforceDepartment(parsed['prestate']);
    setIsInitialized(true);
  }, []);

  useEffect(
    () => {
      if (props.location.pathname !== previousPage) {
        let tag = (props.location.pathname || '').replace('/wm', '');
        if (props.location.pathname.indexOf('basic') > -1) {
          tag = 'basic';
        } else if (props.location.pathname.indexOf('profile') > -1) {
          tag = 'profile';
        } else if (props.location.pathname.indexOf('extended') > -1) {
          tag = 'extended';
        }
        if (tag) {
          props.analytics.page(tag, '/wm');
        }
        setPreviousPage(props.location.pathname);
        checkRequisites();
      }
    },
    [props.location],
  );

  const checkRequisites = () => {
    const locat = STEPS_CONTROL_DISQUALIFIED.find((x) => x.id === props.location.pathname.replace('/wm/', ''));
    if (!locat) {
      return;
    }
    for (let index = 0; index < locat.requisite.length; index++) {
      const element = locat.requisite[index];
      if (state[element]) {
      } else {
        // console.log('notFound');
        if (element === 'hypothyroidism') {
          props.history.replace(`/wm/hypo-diagnosed`);
        } else {
          const target = STEPS_CONTROL_DISQUALIFIED.find((x) => x.set.indexOf(element) > -1);
          if (!target) continue;
          if (target.id === 'prequal') {
            props.history.replace(`/wm`);
            return;
          }
          props.history.replace(`/wm-registration/${target.id}`);
        }
      }
    }
  };

  const handleSubmit = (values, actions, wizard, force) => {
    if (!!actions && !!actions.setSubmitting) {
      actions.setSubmitting(false);
    }
    if (!!force) {
      wizard.push(force);
    } else {
      wizard.next();
    }
  };

  const handleChange = (id, value, clearValue) => {
    const s = JSON.parse(JSON.stringify(state));
    s[id] = value;
    if (!!clearValue) {
      if (Array.isArray(clearValue)) {
        for (let index = 0; index < clearValue.length; index++) {
          const element = clearValue[index];
          delete s[element];
        }
      } else {
        delete s[clearValue];
      }
    }
    setState(s);
    const d = JSON.stringify(s);
    window.sessionStorage.setItem('wmi', d);
  };

  const handleChangeMultiple = (idValues) => {
    const s = JSON.parse(JSON.stringify(state));
    for (let index = 0; index < idValues.length; index++) {
      const element = idValues[index];
      const { id, value } = element;
      s[id] = value;
    }

    setState(s);
    const d = JSON.stringify(s);
    window.sessionStorage.setItem('wmi', d);
  };

  const handleComplete = async (values, medicalConsent, wizard) => {
    const { toastManager, analytics } = props;
    setIsCreating(true);
    const wmi = JSON.parse(window.sessionStorage.getItem('wmi'));
    const {
      dob,
      assignedsexatbirth,
      firstName,
      lastName,
      street1,
      street2,
      zip,
      city,
      state,
      phone,
      email,
      medicationHistoryConsentVerified,
      genderidentity,
      gender,
      otherGenderIdentity,
      preferredpronouns,
      hypothyroidism,
    } = wmi;

    const { isSubscribe, continueWith, frequency, forwardToSelectPlan, trial, enforceDepartment } = state;
    let charts = mutationPrep(wmi);
    let diagnosed = !!hypothyroidism || false;

    try {
      let fbclid = getFbclid();
      let fbp = getFbp();
      let ga_client_id = getGa();
      let gclid = getGclAw();
      const { data } = await props.client.mutate({
        mutation: SIGNUP,
        variables: {
          email: values.email,
          phone: phone,
          password: values.password,
          firstName: firstName,
          lastName: lastName,
          street1: street1,
          street2: street2,
          city: city,
          state: state,
          zip: zip,
          dob: dob,
          gender: gender || assignedsexatbirth,
          diagnosed: diagnosed && diagnosed !== 'N' && diagnosed !== 'No',
          medicationHistoryConsentVerified: medicationHistoryConsentVerified === 'yes',
          genderidentity: !!genderidentity ? genderidentity : assignedsexatbirth === 'M' ? 'Identifies as Male' : 'Identifies as Female',
          genderidentityother: otherGenderIdentity,
          preferredpronouns: preferredpronouns,
          assignedsexatbirth: assignedsexatbirth,
          isNPThyroid: false,
          oneTimeException: false,
          diagnosedNote: diagnosed && diagnosed !== 'N' && diagnosed !== 'No' ? 'Y' : '',
          fbclid,
          fbp,
          ga_client_id,
          gclid,
        },
      });

      const attemptedRoute = localStorage.getItem('route');
      localStorage.setItem('token', data.signup.token);
      const aa = await props.client.query({
        query: GET_ANALYTICS_ID,
        fetchPolicy: 'network-only',
      });
      let age = 0;
      try {
        age = moment().diff(moment(dob, 'MM/DD/YYYY'), 'years');
      } catch (error) {}
      if (aa && aa.data && aa.data.getAnalyticsId) {
        analytics.Alias(aa.data.getAnalyticsId);
        analytics.Identify(aa.data.getAnalyticsId, {
          age,
          gender: gender,
          state: state,
          diagnosed: diagnosed,
        });
      }

      analytics.track('Account Created', {
        age,
        gender: gender,
        diagnosed: diagnosed,
        state: state,
      });
      window.sessionStorage.removeItem('wmi');
      window.localStorage.removeItem('wm-d');
      window.localStorage.removeItem('wm-df');
      setIsCreating(false);
      await goToPurchase();
    } catch (error) {
      console.log(error);
    }
  };
  const goToPurchase = async () => {
    props.history.push('/post-register');
    // todo forward to list of services
  };

  if (loading || !isInitialized) {
    return <LoadingScreen loading={true} />;
  }

  return (
    <Fragment>
      <Container flex={1} px={3}>
        <Wizard
          history={props.history}
          basename="/wm-registration"
          render={({ step, ...p }, a) => {
            return (
              <>
                <Flex flexDirection={'row'} style={{ width: '100%', height: '6px' }} mt={2} id="pgbar">
                  <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: '#6aac6e', opacity: 0.33, width: '33px' }} />
                  <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: 'rgba(0, 0, 0, 0.12)', marginLeft: '12px' }} flex={1} id="ttt">
                    <Pb
                      flex={(p.steps.findIndex((x) => x.id === step.id) + 1) / p.steps.length}
                      style={{ background: theme.color.pink, borderTopRightRadius: '3px', borderBottomRightRadius: '3px' }}
                    />
                    <Pb flex={1 - (p.steps.findIndex((x) => x.id === step.id) + 1) / p.steps.length} style={{ background: 'transparent' }} />
                  </Flex>
                  <Flex style={{ height: '6px', overflow: 'hidden', borderRadius: '3px', background: 'rgba(0, 0, 0, 0.12)', width: '33px', marginLeft: '12px' }} />
                </Flex>
                <Steps>
                  <Step id="profile">
                    <ComponentWrap>
                      <LogoSvg />
                      <Profile
                        onContinue={() => {
                          if (!state['mfa'] || state['mfa'] !== 'ok') {
                            p.push('otp');
                          } else {
                            p.push('birthsex');
                          }
                        }}
                        state={state}
                        enforceDepartment={enforceDepartment}
                        onChange={handleChange}
                        onChangeMultiple={handleChangeMultiple}
                      />
                    </ComponentWrap>
                  </Step>
                  <Step id="otp">
                    <ComponentWrap>
                      <LogoSvg />
                      <Otp state={state} onChange={handleChange} onChangeMultiple={handleChangeMultiple} onContinue={() => p.push('birthsex')} />
                    </ComponentWrap>
                  </Step>
                  <Step id="birthsex">
                    <ComponentWrap>
                      <LogoSvg />
                      <BirthSex
                        onSubmit={handleSubmit}
                        state={state}
                        onChange={handleChange}
                        onContinue={() => {
                          if (state['state'] === 'CA') {
                            p.push('medical-history-consent');
                          } else {
                            p.push('account');
                          }
                        }}
                        onChangeIdentify={() => p.push('legalsex')}
                      />
                    </ComponentWrap>
                  </Step>
                  <Step id="legalsex">
                    <ComponentWrap>
                      <LogoSvg />
                      <LegalSex state={state} onChange={handleChange} onContinue={() => p.push('genderIdentity')} onSubmit={handleSubmit} values={state} />
                    </ComponentWrap>
                  </Step>
                  <Step id="genderIdentity">
                    <ComponentWrap>
                      <LogoSvg />
                      <GenderIdentity onSubmit={handleSubmit} state={state} onChange={handleChange} onChangeMultiple={handleChangeMultiple} onContinue={() => p.push('pronouns')} />
                    </ComponentWrap>
                  </Step>
                  <Step id="pronouns">
                    <ComponentWrap>
                      <LogoSvg />
                      <PreferredPronouns
                        state={state}
                        onChange={handleChange}
                        onChangeMultiple={handleChangeMultiple}
                        onContinue={() => {
                          if (state['state'] === 'CA') {
                            p.push('medical-history-consent');
                          } else {
                            p.push('account');
                          }
                        }}
                      />
                    </ComponentWrap>
                  </Step>
                  <Step id="medical-history-consent">
                    <ComponentWrap>
                      <LogoSvg />
                      <Extended onChange={handleChange} onContinue={() => p.push('account')} state={state} />
                    </ComponentWrap>
                  </Step>
                  <Step id="account">
                    <ComponentWrap>
                      <LogoSvg />
                      <Basic onSubmit={handleComplete} state={state} onChange={handleChange} isCreating={isCreating} />
                    </ComponentWrap>
                  </Step>
                </Steps>
              </>
            );
          }}
        />
      </Container>
      <FullLayout />
    </Fragment>
  );
};

export default compose(
  withCookies,
  withApollo,
  withRouter,
  withToastManager,
  withAnalytics,
)(RegistrationWeightLoss);
